import {useFlags} from "launchdarkly-react-client-sdk";
import {Runtime} from "@common-core/runtime-js/runtime";
import {features} from "../features";

export function useInspector<M>(runtime: Runtime<M>): boolean {
  const flags = useFlags();
  return flags[features.ops.runtimeInspectorVisible];
}
